import julia1 from '../images/julia1.jpeg'
import julia2 from '../images/julia2.jpg'
import julia3 from '../images/julia3.jpg'


export const juliasData = [
    {
        paragraphOne: 'Julia пропусна елегантен аперитив, приготвен у дома, в менюто, на партита и светски събирания.',
        paragraphTwo: `Нейната идея беше да донесе сварен аперитив,
        което е донесено с повече стил и елегантност,
        което също е много достъпно от гледна точка на вкус
        и умерено до ниско съдържание на алкохол.`,
        imgUrl: julia1,
        className: false,
    },
    {
        paragraphOne: `Julia предлага високо качество на белгийско гурме ниво.
        Не традиционният белгийски стил.`,
        paragraphTwo: `Това е личен проект на белгийско семейство, включително самата Julia, която иска да сподели какво обича.`,
        imgUrl: julia2,
        className: true,
    },
    {
        paragraphOne: `Julia обича да създава щастие и незабравими спомени.
        Julia обича елегантни, модерни гурме аперитиви и храна.
        Julia обича да бъде сред хората и да споделя тези моменти с най-добрите си приятели и семейство.`,
        paragraphTwo: `Jula е за живота.`,
        imgUrl: julia3,
        className: false,
    }
]